const getShoppingCartProductName = ({type, id} = {}) => [type, id].filter((el) => el).join('_');

module.exports = {
    getShoppingCartProductName,
};
